define('services/settings',["require", "exports", "services/aaausermanager", "services/simpleusermanager", "models/environment", "common/string", "services/settings"], function (require, exports, AAAUserManager, SimpleUserManager, Environment, Strings, Configuration) {
    "use strict";
    var Settings = (function () {
        function Settings() {
        }
        //#region environment settings
        Settings.initialize = function () {
            // adding custom theme.
            $('head').append('<link rel="stylesheet" href="' + this.getPublicApiFor("api/configuration/subdomains/" + this.getPortalDomain() + "/theme/css?v=" + Date.now()) + '"  />');
            var domain = window.location.host.substring(window.location.host.indexOf(".") + 1);
            var subdomain = window.location.host.split('.')[0];
            // check if features/aaa flags are cached in session storage to prevent re-loading after authentication redirect.
            var featuresJson = sessionStorage.getItem('featuresJson');
            if (!featuresJson) {
                var aaaFlagsRelativeUrl = "/activation/api/aaamigration/aaaflags/subdomain/" + subdomain;
                var aaaFlagsUrl = "https://" + subdomain + "." + domain + aaaFlagsRelativeUrl;
                if (window.location.host.indexOf("addison51.de") > -1)
                    aaaFlagsUrl = "http://localhost:8013" + aaaFlagsRelativeUrl;
                var requests = [];
                requests.push($.ajax({
                    url: '/html/config/features.json',
                    context: document.body
                }));
                requests.push($.ajax({
                    url: aaaFlagsUrl,
                    context: document.body,
                    crossDomain: true
                }));
                // run requests in parallel then this function
                return Q.all(requests).then(function (results) {
                    var features = results[0];
                    var aaaConfigurationData = results[1];
                    features.userManager.aaaConfiguration = aaaConfigurationData;
                    features.userManager.type = aaaConfigurationData.isAAAEnabled ? "trippleA" : "simple";
                    if (aaaConfigurationData.isSSOEnabled) {
                        localStorage.setItem('federation', 'true');
                    }
                    else {
                        localStorage.setItem('federation', 'false');
                    }
                    // store the features in session storage to prevent them being reloaded after a redirect following oidc auth.
                    sessionStorage.setItem('featuresJson', JSON.stringify(features));
                    Settings.completeSetup(features, subdomain);
                });
            }
            else {
                // parse the features from the cached version and complete setup.
                var features = JSON.parse(featuresJson);
                Settings.completeSetup(features, subdomain);
                return Q.resolve(true);
            }
        };
        Settings.completeSetup = function (features, subdomain) {
            Settings.environmentSettings = new Environment.Configuration(features);
            // If the practice is not found then redirect to a 404 page.
            if (features.userManager.aaaConfiguration.practiceGuid == "00000000-0000-0000-0000-000000000000" && subdomain != "addison") {
                window.location.assign("/html/static/404.html");
            }
        };
        Object.defineProperty(Settings, "environment", {
            get: function () {
                return this.environmentSettings;
            },
            enumerable: true,
            configurable: true
        });
        Settings.createUserManager = function () {
            var type = this.getParam("uam") || this.environment.userManager.type;
            if (this.environment.userManager.aaaConfiguration) {
                type = this.environment.userManager.aaaConfiguration.isAAAEnabled ? "trippleA" : "simple";
            }
            var clientId = this.getParam("clientId") || this.environment.userManager.clientId;
            var leadingApp = this.getParam("leadingApp") || this.environment.userManager.leadingApplication;
            var locationSearch = window.location.search;
            var isDirectLogin = Strings.contains(locationSearch, "nid=") ||
                Strings.contains(locationSearch, "session=") ||
                Strings.contains(locationSearch, "secret=");
            if (isDirectLogin) {
                return new SimpleUserManager();
            }
            // normal evaluation
            switch (type) {
                case "trippleA":
                    return new AAAUserManager(clientId, leadingApp);
                default:
                    return new SimpleUserManager();
            }
        };
        Object.defineProperty(Settings, "useHelpSystem", {
            get: function () {
                var value = this.environment.getCustomValue("UseHelpSystem");
                return value === undefined || value == null || value.toLowerCase() === "true";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Settings, "mainLogoPath", {
            //#endregion
            get: function () {
                var customLogoSetting = this.environment.getCustomValue("CustomLogo");
                var allowCustomLogo = customLogoSetting && customLogoSetting.toLowerCase() === "true";
                if (allowCustomLogo) {
                    return this.getApiFor("api/logo/" + this.getPortalDomain());
                }
                else {
                    return Configuration.Settings.environment.getCustomValue("CdnEndPoint") + "content/images/addison_logo.png";
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Settings, "isProductiveSystem", {
            get: function () {
                return this.serverUrl === "portalbereich.de" || this.serverUrl === "one-click.de";
            },
            enumerable: true,
            configurable: true
        });
        Settings.getPortalDomain = function () {
            var hostname = window.location.hostname;
            if (this.isLocalSystem())
                return "addison";
            var domain = hostname.substring(0, hostname.indexOf("."));
            return domain;
        };
        Settings.getHost = function () {
            if (this.isLocalSystem())
                return "https://addison.addison51.de";
            return this.getUrlScheme() + "://" + window.location.hostname;
        };
        Settings.getLocalPath = function () {
            return "/html";
        };
        Settings.getApiFor = function (path) {
            return this.getServiceFor("aip", path, null);
        };
        Settings.getApiForChat = function () {
            return this.environmentSettings.chat.serviceurl;
        };
        Settings.getPublicApiFor = function (path) {
            return this.getServiceFor("oneclick", path, null);
        };
        Settings.getOneClickServicesApi = function (path) {
            if (window.location.origin.indexOf("addison51.de") > -1)
                return "http://localhost:8013" + path;
            return window.location.origin + path;
        };
        Settings.getClientPortalApi = function (path) {
            var subdomain = window.location.host.split('.')[0];
            if (window.location.origin.indexOf("addison51.de") > -1)
                return "https://" + subdomain + ".accountantspace-dev.co.uk/messages/" + path;
            return window.location.origin + "/messages/" + path;
        };
        Settings.getPracticePortalApi = function (path) {
            var subdomain = window.location.host.split('.')[0];
            if (window.location.origin.indexOf("addison51.de") > -1)
                return "https://" + subdomain + ".accountantspace-dev.co.uk/practice-portal/" + path;
            return window.location.origin + "/practice-portal/" + path;
        };
        Settings.getServiceFor = function (serviceName, path, query) {
            if (path.substring(0, 1) != "/") {
                path = "/" + path;
            }
            var uri = this.getUrlScheme() + "://" + window.location.hostname + "/servicehosts/" + serviceName + path;
            if (query != null && query != "")
                uri += query;
            return uri;
        };
        Settings.getTokenType = function () {
            return "Bearer ";
        };
        Settings.getScope = function () {
            return this.getUrlScheme() + "://" + "addison." + this.serverUrl;
        };
        Object.defineProperty(Settings, "serverUrl", {
            get: function () {
                if (this.isLocalSystem())
                    return "addison51.de";
                var hostname = window.location.hostname;
                var domain = hostname.substring(hostname.indexOf(".") + 1);
                switch (domain) {
                    case 'one-click.de':
                        domain = 'portalbereich.de';
                        break;
                }
                if (window.location.port !== "443" && window.location.port !== "")
                    domain += ":" + window.location.port;
                return domain;
            },
            enumerable: true,
            configurable: true
        });
        Settings.getUrlScheme = function () {
            return this.useSsl ? "https" : "http";
        };
        Settings.getTokenExchangeEndpoint = function () {
            var domain = window.location.host.substring(window.location.host.indexOf(".") + 1);
            var subdomain = window.location.host.split('.')[0];
            var relativeUrl = "/tokenexchange/api/auth";
            var url = "https://" + subdomain + "." + domain + relativeUrl;
            if (window.location.host.indexOf("addison51.de") > -1)
                url = "http://localhost:8027" + relativeUrl;
            return url;
        };
        Settings.isLocalSystem = function () {
            return window.location.hostname === "localhost";
        };
        Settings.isLocalSystemExtended = function () {
            return window.location.hostname === "tes66";
        };
        Settings.getParam = function (variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i_1 = 0; i_1 < vars.length; i_1++) {
                var pair = vars[i_1].split("=");
                if (pair[0] === variable) {
                    return pair[1];
                }
            }
            return null;
        };
        Settings.useSsl = true;
        Settings.environmentSettings = null;
        return Settings;
    }());
    exports.Settings = Settings;
});

